import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import PublicConciergeGate from "./PublicConciergeGate";
import { Link, useLocation } from "react-router-dom";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const hideMobileDock = pathname.startsWith("/booking/") || pathname.endsWith("/reserve");
  return (
    <div className="editorial min-h-screen flex flex-col bg-[#FAFAF7]">
      <Navbar />
      <main className="flex-1 pb-24 lg:pb-0">{children}</main>
      <Footer />
      <WhatsAppButton />
      <PublicConciergeGate />
      {!hideMobileDock && (
        <div className="ed-dock lg:hidden" data-testid="mobile-booking-dock">
          <div className="leading-tight">
            <p className="ed-overline" style={{ fontSize: "0.6rem", letterSpacing: "0.28em", color: "var(--ed-emerald)" }}>Short &amp; long stays available</p>
            <p className="font-serif text-base" style={{ color: "var(--ed-ink)" }}>Reserve your stay</p>
          </div>
          {pathname === "/long-stay" ? (
            <a
              href="#enquiry"
              data-testid="mobile-dock-book"
              className="ed-btn-primary"
              style={{ padding: "0.85rem 1.5rem", fontSize: "0.68rem" }}
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("enquiry")?.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
            >
              Enquire
            </a>
          ) : (
            <Link
              to="/properties"
              data-testid="mobile-dock-book"
              className="ed-btn-primary"
              style={{ padding: "0.85rem 1.5rem", fontSize: "0.68rem" }}
            >
              Book
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
